export class Company {
    public id: string;
    public name: string;
    public site: string;
    public namespace: string;

    constructor(obj: any) {
        this.id = obj.id || '';
        this.name = obj.organization_name || '';
        this.site = obj.organization_site || '';
        this.namespace = obj.namespace || '';
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/classes/company/company.ts